(ns dashboard.views.browser-extension.questionnaire-list.view
  (:require [re-frame.core :as rf]
            [reitit.frontend.easy :as rfe]
            [dashboard.views.browser-extension.questionnaire.config :as questionnaire-config]
            [dashboard.views.browser-extension.new-questionnaire.config :as new-questionnaire-config]
            [dashboard.browser-extension :as browser-extension]
            [dashboard.services.questionnaire-list :as questionnaire-list]))

(defn questionnaires-page []
  ;; TODO: list only portal questionnaires
  (let [questionnaires @(rf/subscribe [::questionnaire-list/data])]
    (rf/dispatch [::browser-extension/send-event {:type :questionnaire-selected :questionnaire nil}])
    [:div.section.pt-6.browser-extension-questionnaire-list
     [:p.title.is-centered.is-5 "Questionnaires"]
     [:p.subtitle.is-6 "Select a questionnaire or create a new one"]

     (when (empty? questionnaires)
       [:div.box.has-background-primary
        [:div.block>b "No portal questionnaires created yet"]
        [:img {:src "/img/fly.svg" :style {:width "100px"}}]
        [:div.block "You can start by creating a new questionnaire below."]])

     [:div.table
      (map (fn [{:keys [id filename custom-name]}]
             (let [url (rfe/href questionnaire-config/view-id {:id (str id)})]
               [:div.table-row.is-flex.is-flex-direction-row.is-align-items-center.p-1
                {:key (str id)}
                [:a.is-flex-grow-1.px-1
                 {:style {:text-overflow "ellipsis"
                          :overflow "hidden"
                          :white-space "nowrap"}
                  :href url}
                 (or filename custom-name)]
                [:a.button.is-secondary.is-small
                 {:href url
                  :title "Open questionnaire"}
                 [:span.icon>i.fas.fa-caret-right]]]))
           questionnaires)]

     [:div.field.is-flex.is-justify-content-center
      [:a.button.is-small.is-link.is-rounded
       {:href (rfe/href new-questionnaire-config/view-id)
        :title "Open a form for creating a new questionnaire"}
       "Create New Questionnaire"]]]))
